import { render, staticRenderFns } from "./Termine.vue?vue&type=template&id=351251b2&scoped=true&"
import script from "./Termine.vue?vue&type=script&lang=js&"
export * from "./Termine.vue?vue&type=script&lang=js&"
import style0 from "./Termine.vue?vue&type=style&index=0&id=351251b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351251b2",
  null
  
)

export default component.exports